import React, { useState, useEffect } from "react";
import { ProgressSpinner } from "primereact/progressspinner";
import { useNavigate } from "react-router-dom";
import { getUserData } from "../../utils/localStorage";
import { Accordion, AccordionTab } from "primereact/accordion";
import {
  formatDateWithTime,
} from "../../constants/DateUtil/DateUtil";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import {
  getStoreExternalWarehouseChallan,
  searchStoreExternalWarehouseChallan,
} from "../../services/StoreExternalWarehouse/StoreExternalWarehouse";

const StoreExternalWarehouseChallan = () => {
  const navigate = useNavigate();

  const { storeData } = getUserData();

  const storeId = storeData.id;
  const [loading, setLoading] = useState(true);

  const [searchTerm, setSearchTerm] = useState("");
  const [searchTermView, setSearchTermView] = useState(false);

  // DataProvider and LayoutProvider for RecyclerListView
  const [dataProvider, setDataProvider] = useState([]);

  const fetchStoreExternalWarehouseChallan = (data) => {
    getStoreExternalWarehouseChallan(data)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setDataProvider(Res); // Update DataProvider
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    const data = {
      storeId: storeId,
    };
    fetchStoreExternalWarehouseChallan(data);
  }, []);

  useEffect(() => {
    const data = {
      storeId: storeId,
      searchBy: "challanNumber",
      searchText: searchTerm,
      sortOrder: "desc",
      sortBy: "id",
      offset: 0,
      limit: 10000,
      startDate: "",
      endDate: "",
      statusIn: ["create", "sent"],
    };
    fetchSearchStoreExternalWarehouseChallan(data);
  }, [searchTerm]);

  const fetchSearchStoreExternalWarehouseChallan = (data) => {
    searchStoreExternalWarehouseChallan(data)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setDataProvider(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const rowRenderer = () => {
    return dataProvider?.map((item, index) => {
      const OrderStatusColors = {
        SENT_TO_STORE: "#f76aa0",
        SENT_TO_WARE_HOUSE: "#F4C430",
        DEFAULT: "#F5C43A",
      };

      const orderStatusColor =
        OrderStatusColors[item.challanTypeStatus] || OrderStatusColors.DEFAULT;
      const formattedDeliveryDate = formatDateWithTime(item.createdDate);
      const challanTypeStatus =
        item.challanTypeStatus === "SENT_TO_WARE_HOUSE"
          ? "Sent To WH"
          : "Received From WH";
      return (
        <Accordion>
          <AccordionTab
            key={index}
            style={{
              "--backgroundColor-AccordionTab": orderStatusColor,
            }}
            header={`${index + 1 || "N/A"} | ${formattedDeliveryDate} `}
          >
            <div className="flex-row">
              <div className="flex-row flex-1 cursor-pointer">
                <div className="col-4">
                  <p className="text-base font-semiBold capitalize">
                    Challan Number:
                  </p>
                  <p className="text-lg font-bold capitalize">
                    {item.challanNumber}
                  </p>
                </div>
                <div className="col-4">
                  <p className="text-base font-semiBold capitalize">
                    Challan To:
                  </p>
                  <p className="text-lg font-bold capitalize">
                    {item.challanTo}
                  </p>
                </div>
                <div className="col-4">
                  <p className="text-base font-semiBold capitalize">
                    Deliver Details:
                  </p>
                  <p className="text-lg font-bold capitalize">
                    {item.driverDetail}
                  </p>
                </div>
              </div>
            </div>
            <div className="flex-row">
              <div className="flex-row flex-1 cursor-pointer">
                <div className="col-4 flex">
                  <div className="flex-1">
                    <p className="text-base font-semiBold capitalize">
                      Vehicle Detail:
                    </p>
                    <p className="text-lg font-bold capitalize">
                      {item.vehicleDetail}
                    </p>
                  </div>
                </div>
                <div className="col-4 flex">
                  <div className="flex-1">
                    <p className="text-base font-semiBold capitalize">
                      Other Info:
                    </p>
                    <p className="text-lg font-bold capitalize">
                      {item.otherInfo}
                    </p>
                  </div>
                </div>
                <div className="col-4 flex gap-4">
                  <div
                    className="flex justify-content-center align-items-center cursor-pointer"
                    onClick={() =>
                      navigate("/StoreExternalWarehouseChallanAdd", {
                        state: {
                            item: item,
                        },
                      })
                    }
                  >
                    <i
                    className="pi pi-pencil"
                    style={{
                      fontSize: "25px",
                      color: "#1752AA",
                    }}
                  ></i>
                  </div>
                  <div
                    className="flex justify-content-center align-items-center cursor-pointer"
                    onClick={() =>
                      navigate("/StoreExternalWarehouseQrCode", {
                        state: {
                          item: item,
                        },
                      })
                    }
                  >
                    <img src={"warehouse/warehouse_4.png"} style={{ width: 35 }} />
                  </div>
                  <div
                    className="flex justify-content-center align-items-center cursor-pointer"
                    onClick={() =>
                      navigate("/StoreExternalWarehouseChallanQrcodeData", {
                        state: {
                          item: item,
                        },
                      })
                    }
                  >
                    <img src={"Laundy_App_Icons_Gifs/Other_Icons/View_QR_Code.png"} style={{ width: 35 }} />
                  </div>
                  <div
                    className="flex justify-content-center align-items-center cursor-pointer"
                    onClick={() =>
                      navigate("/StoreExternalWarehouseChallanAdd", {
                        state: {
                          item: item,
                          duplicate: true,
                        },
                      })
                    }
                  >
                    <i
                    className="pi pi-clone"
                    style={{
                      fontSize: "30px",
                      color: "#1752AA",
                    }}
                  ></i>
                  </div>
                </div>
              </div>
            </div>
          </AccordionTab>
        </Accordion>
      );
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold">
                External Warehouse Challan
              </p>
            </div>
          </div>
          <div
            onClick={() =>
              navigate("/StoreExternalWarehouseChallanAdd", {
                item: null,
              })
            }
            className="mx-2 cursor-pointer flex align-items-center"
          >
            <img
              style={{
                height: 25,
                width: 25,
                marginRight:20,
              }}
              src={"images/plus.png"}
            />
          </div>

          <div
            onClick={() => setSearchTermView(!searchTermView)}
            className="mx-2 cursor-pointer flex align-items-center"
          >
            <i
              className="pi pi-search"
              style={{ fontSize: "25px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      {searchTermView && (
        <div className="mt-2 mx-4 flex">
          <div className=" flex flex-1">
            <IconField iconPosition="left" className="flex flex-1">
              <InputIcon className="pi pi-search text-xl"> </InputIcon>
              <InputText
                placeholder="Search Challan No."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="text-xl flex flex-1 py-1 px-5"
                style={{ borderRadius: 30 }}
                keyboardType="numeric"
                maxLength={25}
              />
            </IconField>
          </div>
          {searchTerm.length > 0 && (
            <div
              className="mx-3 cursor-pointer"
              onClick={() => setSearchTerm("")}
            >
              <p className="text-3xl font-Bold" style={{ color: "red" }}>
                X
              </p>
            </div>
          )}
        </div>
      )}
      <div className="mx-4 my-4">
        {loading ? (
          <div className="flex-1 flex flex-column justify-content-center align-items-center">
            <ProgressSpinner />

            <p className="text-3xl font-Bold">
              External Warehouse List is Loading...
            </p>
          </div>
        ) : dataProvider.length === 0 ? (
          <div className="flex-1 flex flex-column justify-content-center align-items-center">
            <p className="text-3xl font-Bold">No External Warehouse Found</p>
          </div>
        ) : (
          rowRenderer()
        )}
      </div>
    </div>
  );
};

export default StoreExternalWarehouseChallan;
